<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="closeModal" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img src="./../image/close.svg" class="close" @click="closeModal" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="cart-up" v-if="step === 1">
                  <div class="cart-top">
                    <div class="desc">
                      <b>{{ $t("OFFER DETAILS") }}</b>
                    </div>
                  </div>
                  <div class="topup-form">
                    <div class="detail-row">
                      <span class="label">{{ $t("Item") }}:</span>
                      <span class="value">{{ offer.title }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="label">{{ $t("Quality") }}:</span>
                      <span class="value">{{ offer.quality }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="label">{{ $t("Your Price") }}:</span>
                      <span class="value"
                        >{{ offer.currency }} {{ offer.user_price }}</span
                      >
                    </div>
                    <div class="detail-row" v-if="offer.service_price">
                      <span class="label">{{ $t("Our Offer") }}:</span>
                      <span class="value"
                        ><b
                          >{{ offer.currency }} {{ offer.service_price }}</b
                        ></span
                      >
                    </div>
                    <div class="detail-row">
                      <span class="label">{{ $t("Status") }}:</span>
                      <span class="value">{{
                        formatStatus(offer.status)
                      }}</span>
                    </div>

                    <div v-if="offer.status === 'offer'" class="button-group">
                      <button class="button orange" @click="acceptOffer">
                        {{ $t("Accept Offer") }}
                      </button>
                      <button class="button red" @click="declineOffer">
                        {{ $t("Decline Offer") }}
                      </button>
                    </div>

                    <div v-if="offer.status === 'ready_for_payout'">
                      <button class="button orange" @click="step = 2">
                        {{ $t("Request Payout") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="cart-up" v-if="step === 2">
                  <div class="cart-top">
                    <div class="desc">
                      <b>{{ $t("CONTACT INFORMATION") }}</b>
                    </div>
                  </div>
                  <div class="topup-form">
                    <div class="desc">
                      {{ $t("PAYMENT METHOD:") }}
                    </div>
                    <div class="desc">
                      {{ $t("CREDIT CARD") }}
                    </div>

                    <label class="input-container">
                      <div class="desc">{{ $t("Email") }}</div>
                      <input
                        v-model="email"
                        type="email"
                        :placeholder="$t('Email')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Name") }}</div>
                      <input
                        v-model="name"
                        type="text"
                        :placeholder="$t('Name')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Surname") }}</div>
                      <input
                        v-model="surname"
                        type="text"
                        :placeholder="$t('Surname')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Phone") }}</div>
                      <input
                        v-model="phone"
                        type="tel"
                        :placeholder="$t('Phone')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Country") }}</div>
                      <select required v-model="selectedCountry">
                        <option value="" disabled selected>
                          {{ $t("Countries") }}
                        </option>
                        <option
                          v-for="item in countries"
                          :key="item.id"
                          :value="item"
                        >
                          {{ item.title }}
                        </option>
                      </select>
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("City") }}</div>
                      <input
                        v-model="city"
                        type="text"
                        :placeholder="$t('City')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Address") }}</div>
                      <input
                        v-model="address"
                        type="text"
                        :placeholder="$t('Address')"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Post Code") }}</div>
                      <input
                        v-model="postCode"
                        type="text"
                        :placeholder="$t('Post Code')"
                        required
                      />
                    </label>
                    <div v-if="!isContactValid" class="validation-hint">
                      {{ $t("Please fill all contact information") }}
                    </div>
                    <button
                      class="button orange"
                      @click="step = 3"
                      :disabled="!isContactValid"
                    >
                      {{ $t("Next") }}
                    </button>
                  </div>
                </div>

                <div class="cart-up" v-if="step === 3">
                  <div class="cart-top">
                    <div class="desc">
                      <b>{{ $t("CARD INFORMATION") }}</b>
                    </div>
                  </div>
                  <div class="topup-form">
                    <div class="desc">
                      {{ $t("Enter your card details") }}
                    </div>

                    <label class="input-container">
                      <div class="desc">{{ $t("Card Number") }}</div>
                      <input
                        v-model="formattedPan"
                        type="text"
                        placeholder="1234 5678 9012 3456"
                        maxlength="19"
                        @input="formatCardNumber"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Cardholder Name") }}</div>
                      <input
                        v-model="cardHolderName"
                        type="text"
                        placeholder="JOHN DOE"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Expiration Month") }}</div>
                      <input
                        v-model="expireMonth"
                        type="text"
                        placeholder="MM"
                        maxlength="2"
                        required
                      />
                    </label>
                    <label class="input-container">
                      <div class="desc">{{ $t("Expiration Year") }}</div>
                      <input
                        v-model="expireYear"
                        type="text"
                        placeholder="YY"
                        maxlength="2"
                        required
                      />
                    </label>
                    <div v-if="!isCardValid" class="validation-hint">
                      <span
                        v-if="formattedPan.replace(/\s/g, '').length < 12"
                        >{{
                          $t("Card number must be at least 12 digits")
                        }}</span
                      >
                      <span v-else-if="cardHolderName.length < 3">{{
                        $t("Cardholder name must be at least 3 characters")
                      }}</span>
                      <span v-else-if="expireMonth.length !== 2">{{
                        $t("Enter expiration month (MM)")
                      }}</span>
                      <span v-else-if="expireYear.length !== 2">{{
                        $t("Enter expiration year (YY)")
                      }}</span>
                    </div>
                    <button
                      class="button orange"
                      @click="submitPayout"
                      :disabled="!isCardValid || loading"
                    >
                      <span v-if="loading">{{ $t("Processing...") }}</span>
                      <span v-else>{{ $t("Submit Payout Request") }}</span>
                    </button>
                  </div>
                </div>

                <div v-if="error" class="error-message">{{ error }}</div>
                <div v-if="success" class="success-message">{{ success }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferModal",
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      step: 1,
      email: "",
      name: "",
      surname: "",
      phone: "",
      selectedCountry: "",
      countries: [],
      city: "",
      address: "",
      postCode: "",
      formattedPan: "",
      cardHolderName: "",
      expireMonth: "",
      expireYear: "",
      error: "",
      success: "",
      loading: false,
    };
  },
  computed: {
    isContactValid() {
      return (
        this.email &&
        this.name &&
        this.surname &&
        this.phone &&
        this.selectedCountry &&
        this.city &&
        this.address &&
        this.postCode
      );
    },
    isCardValid() {
      return (
        this.formattedPan.replace(/\s/g, "").length >= 12 &&
        this.cardHolderName.length >= 3 &&
        this.expireMonth.length === 2 &&
        this.expireYear.length === 2
      );
    },
  },
  mounted() {
    this.getCountries();
    this.getProfile();
  },
  methods: {
    getCountries() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countries = res.data.payload;
        })
        .catch(() => {});
    },
    getProfile() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.email = res.data.email || "";
          this.name = res.data.name || "";
          this.surname = res.data.surname || "";
          this.phone = res.data.phone || "";
          this.city = res.data.city || "";
          this.address = res.data.address || "";
          this.postCode = res.data.zip || "";
          if (res.data.country && this.countries.length) {
            this.selectedCountry =
              this.countries.find((c) => c.id == res.data.country) || "";
          }
        })
        .catch(() => {});
    },
    closeModal() {
      this.$emit("close");
    },
    formatStatus(status) {
      return status
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    formatCardNumber(e) {
      let value = e.target.value.replace(/\s/g, "");
      let formatted = value.match(/.{1,4}/g)?.join(" ") || value;
      this.formattedPan = formatted;
    },
    acceptOffer() {
      this.$http
        .post(process.env.VUE_APP_API + "offer/accept", { id: this.offer.id })
        .then((res) => {
          if (res.data.status === "OK") {
            this.success = "Offer accepted successfully!";
            setTimeout(() => {
              this.$emit("refresh");
              this.closeModal();
            }, 2000);
          }
        })
        .catch((err) => {
          this.error = err.response?.data?.message || "Error accepting offer";
        });
    },
    declineOffer() {
      this.$http
        .post(process.env.VUE_APP_API + "offer/decline", { id: this.offer.id })
        .then((res) => {
          if (res.data.status === "OK") {
            this.success = "Offer declined";
            setTimeout(() => {
              this.$emit("refresh");
              this.closeModal();
            }, 2000);
          }
        })
        .catch((err) => {
          this.error = err.response?.data?.message || "Error declining offer";
        });
    },
    async submitPayout() {
      this.loading = true;
      this.error = "";
      this.success = "";

      try {
        const data = {
          id: this.offer.id,
          email: this.email,
          name: this.name,
          surname: this.surname,
          phone: this.phone,
          country: this.selectedCountry.iso || this.selectedCountry.title,
          currency: this.offer.currency,
          city: this.city,
          address: this.address,
          postCode: this.postCode,
          card_number: this.formattedPan.replace(/\s/g, ""),
          card_holder_name: this.cardHolderName,
          expire_month: this.expireMonth,
          expire_year: this.expireYear,
        };

        const res = await this.$http.post(
          process.env.VUE_APP_API + "offer/request-payout/card-direct",
          data
        );

        if (res.data.status === "OK") {
          this.success = "Payout request submitted successfully!";
          setTimeout(() => {
            this.$emit("refresh");
            this.closeModal();
          }, 2000);
        } else {
          this.error = res.data.message || "Payout failed";
        }
      } catch (error) {
        // Handle validation errors
        if (error.response?.data?.errors) {
          const errors = error.response.data.errors;
          const errorMessages = Object.values(errors).flat();
          this.error = errorMessages.join(". ");
        } else {
          this.error = error.response?.data?.message || "An error occurred";
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Override profile page styles */
.modal .wrapper {
  padding: 0 !important;
  gap: 0 !important;
  background: transparent !important;
  display: block !important;
}

.modal input::placeholder {
  font-size: 14px !important;
  color: #9898a9 !important;
}

.topup-form {
  padding: 16px 24px 24px !important;
}

.topup-form .detail-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.topup-form .detail-row .label {
  color: #72738c;
  font-size: 14px;
}

.topup-form .detail-row .value {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.topup-form .button-group {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.topup-form .button-group .button {
  flex: 1;
}

.button.red {
  background: #e74c3c;
  border: 1px solid #e74c3c;
}

.button.red:hover {
  background: #c0392b;
  border-color: #c0392b;
}

.error-message {
  color: #e74c3c;
  padding: 8px;
  margin-top: 8px;
  background: rgba(231, 76, 60, 0.1);
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

.success-message {
  color: #2ecc71;
  padding: 8px;
  margin-top: 8px;
  background: rgba(46, 204, 113, 0.1);
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

.validation-hint {
  color: #ff9800;
  font-size: 13px;
  margin-top: 8px;
  margin-bottom: 8px;
  text-align: center;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.profile-page .hero-section .input-container + .button {
  max-width: 100%;
}
</style>
